class customFilter extends HTMLElement {
    constructor() {
      super();

      const sectionId = document.querySelector(".collection-content").getAttribute('data-section-id');
      this.section = {
        sectionId,
        nodeId: "CollectionAjaxContent"
      }

      this.ajaxCollectionEl = document.querySelector(`#${this.section.nodeId}`);

      this.init();

      document.addEventListener("removeFilter", () => {
        this.removeFilter();
      });
    };

    init() {
        const self = this;
        this.filterItems = this.querySelectorAll("[js-filter-item]");

        this.filterItems.forEach( item => {
            item.addEventListener('change', function() {
                const paramKey = this.dataset.filterParam;
                const paramValue = this.value;

                self.initAjaxCollection(paramKey,paramValue);
            })
        });
    };

    initAjaxCollection(paramKey,paramValue) {
        this.updateHistoryState(paramKey,paramValue);
        this.renderAjaxCollection();
    };

    updateHistoryState(paramKey,paramValue) {
        let queryParams = window.location.search;
        if(window.location.search.includes(paramValue)) {
            queryParams = window.location.search.replace(`${paramKey}=${paramValue}`,'');
        };

        const searchParams = new URLSearchParams(queryParams);

        if(searchParams.has(paramKey)) {
            searchParams.append(paramKey, paramValue);
        }else {
            searchParams.set(paramKey, paramValue);
        };

        const newurl = searchParams;
        if(window.location.search.includes(paramValue)) {
            history.pushState({},'',`${decodeURIComponent('?'.concat(newurl)).replace(`${paramKey}=${paramValue}`,'')}`);
        }else {
            history.pushState({},'',`${decodeURIComponent('?'.concat(newurl))}`);
        }
    };

    removeFilter() {
        this.classList.remove("is-open");
        this.filterItems.forEach( item => item.checked = false )
    }

    renderAjaxCollection() {
        const self = this;
        let url = `${window.location.pathname}?${window.location.search.replace('?','')}${ window.location.search ? '&' : ''}section_id=${this.section.sectionId}`.replace("&&","&");  

        fetch(url).then(function(response) {
            return response.text();
        }).then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            self.classList.remove("is-open");
            const ajaxCollectionEl_ = doc.querySelector(`#${self.section.nodeId}`);

            self.ajaxCollectionEl.innerHTML = ajaxCollectionEl_.innerHTML;

            if(!ajaxCollectionEl_.querySelector(".main-collection-grid").hasChildNodes()) {
                self.ajaxCollectionEl.querySelector(".main-collection-grid").innerHTML = `<p class="message">There are no products based on current filter<p>`
            };

            document.dispatchEvent(new CustomEvent('dropdown:init'));
            self.init.bind(self)
        });
    }
}
  
customElements.define('custom-filter', customFilter);
  